import { CountryPhone } from "@home365/home365-phone-form";
import {AddressModel} from "./address.model";
import {Audit} from "./audit.model";
import {eBusinessType} from "./eBusinessType.enum";
import {EntityFile} from "./entity-file.model";
import {StatusDataModel} from "./status-data.model";
import {eVendorStatus} from "./eVendorStatus.enum";
import {Report1099} from "./report1099.model";
import {StatusMapper} from "./statusMapper";

export class ServicePro {
  accountId: string;
  address: AddressModel;
  audit?: Audit[];
  files: EntityFile[];
  businessType: eBusinessType;
  category: {
    categoryId: string;
    typeId: string;
    categoryName: string;
  }[];
  email: string;
  firstName: string;
  lastName: string;
  locationId: string;
  name: string;
  website: string;
  phoneDetails: CountryPhone;
  status: StatusDataModel<eVendorStatus>;
  report1099: Report1099;
  isAutoAssign: boolean;

  constructor(vendorRes: any) {
    this.accountId = vendorRes.accountId;
    this.address = vendorRes.address;
    this.audit = vendorRes.audit;
    this.files = vendorRes.files;
    this.businessType = vendorRes.businessType ? vendorRes.businessType : eBusinessType.company;
    this.category = vendorRes.category;
    this.email = vendorRes.email;
    this.firstName = vendorRes.firstName;
    this.lastName = vendorRes.lastName;
    this.locationId = vendorRes.locationId;
    this.name = vendorRes.name;
    this.website = vendorRes.website;
    this.phoneDetails = vendorRes.phoneDetails;
    this.phoneDetails.iso = 'US';
    this.status = StatusMapper.getVendorStatusOb(vendorRes.vendorStatus);
    this.report1099 = vendorRes.report1099;
    this.isAutoAssign = vendorRes.isAutoAssign !== false;
  }
}
